module.exports = __webpack_public_path__ + "media/assets/images/logos/ncino_evault_logo_dark-63d29fcbab2882139ba8623a525c0dbf.svg";